var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "700", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$t("kelaBatch.search")) + " "),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.kelaRegions,
                          "item-text": "text",
                          "item-value": "value",
                          label: _vm.$t("kelaBatch.region"),
                          clearable: "",
                          dense: "",
                          outlined: ""
                        },
                        model: {
                          value: _vm.form.Region,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Region", $$v)
                          },
                          expression: "form.Region"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("kelaBatch.year"),
                          type: "number",
                          clearable: "",
                          dense: "",
                          outlined: ""
                        },
                        model: {
                          value: _vm.form.Year,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Year", _vm._n($$v))
                          },
                          expression: "form.Year"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("kelaBatch.tilitysNro"),
                          clearable: "",
                          dense: "",
                          outlined: ""
                        },
                        model: {
                          value: _vm.form.TilitysNro,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "TilitysNro", $$v)
                          },
                          expression: "form.TilitysNro"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("kelaBatch.siirtotunnus"),
                          clearable: "",
                          dense: "",
                          outlined: ""
                        },
                        model: {
                          value: _vm.form.Siirtotunnus,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Siirtotunnus", $$v)
                          },
                          expression: "form.Siirtotunnus"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.feedbackStatusOptions,
                          "item-text": "text",
                          "item-value": "value",
                          label: _vm.$t("kelaBatch.feedbackStatus"),
                          clearable: "",
                          dense: "",
                          outlined: ""
                        },
                        model: {
                          value: _vm.form.FeedbackStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "FeedbackStatus", $$v)
                          },
                          expression: "form.FeedbackStatus"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.combinedTripsOptions,
                          "item-text": "text",
                          "item-value": "value",
                          label: _vm.$t("kelaBatch.containsCombinedTrips"),
                          clearable: "",
                          dense: "",
                          outlined: ""
                        },
                        model: {
                          value: _vm.form.ContainsCombinedTrips,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ContainsCombinedTrips", $$v)
                          },
                          expression: "form.ContainsCombinedTrips"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("kelaBatch.sentFrom"),
                          type: "date",
                          clearable: "",
                          dense: "",
                          outlined: ""
                        },
                        model: {
                          value: _vm.form.SentFrom,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "SentFrom", $$v)
                          },
                          expression: "form.SentFrom"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("kelaBatch.sentTo"),
                          type: "date",
                          clearable: "",
                          dense: "",
                          outlined: ""
                        },
                        model: {
                          value: _vm.form.SentTo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "SentTo", $$v)
                          },
                          expression: "form.SentTo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-btn", { attrs: { text: "" }, on: { click: _vm.clear } }, [
                _vm._v(_vm._s(_vm.$t("kelaBatch.clearFilter")))
              ]),
              _c("v-spacer"),
              _c("v-btn", { attrs: { text: "" }, on: { click: _vm.close } }, [
                _vm._v(_vm._s(_vm.$t("kelaBatch.closeDialog")))
              ]),
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.search } },
                [_vm._v(_vm._s(_vm.$t("common.search")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }